export default "__VITE_ASSET__c5cd30c2__"